import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation as useRouterLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BasketProvider } from "@/context/BasketContext";
import { LocationProvider } from "@/context/LocationContext";
import { Header } from "@/components/Header";
import { MobileNav } from "@/components/MobileNav";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";

import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ProductDetail from "@/pages/ProductDetail";
import SellerProfile from "@/pages/SellerProfile";
import Basket from "@/pages/Basket";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import Orders from "@/pages/Orders";
import Account from "@/pages/Account";
import Auth from "@/pages/Auth";
import SellOnNabor from "@/pages/SellOnNabor";
import Favourites from "@/pages/Favourites";
import SellerDashboard from "@/pages/seller/SellerDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function Shell() {
  const loc = useRouterLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;

  const hideChrome = loc.pathname.startsWith("/seller") || loc.pathname.startsWith("/admin");

  return (
    <div className="App flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/seller/view/:id" element={<SellerProfile />} />
          <Route path="/basket" element={<Basket />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/sell" element={<SellOnNabor />} />
          <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          <Route path="/payment/:result" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/favourites" element={<ProtectedRoute><Favourites /></ProtectedRoute>} />
          <Route path="/seller/*" element={<ProtectedRoute roles={["seller", "admin"]}><SellerDashboard /></ProtectedRoute>} />
          <Route path="/admin/*" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      <MobileNav />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LocationProvider>
          <BasketProvider>
            <Shell />
            <Toaster position="top-center" richColors />
          </BasketProvider>
        </LocationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
